import { Injectable } from "@angular/core";

import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";

import { HttpClient } from "@angular/common/http";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";

@Injectable({
  providedIn: "root",
})
export class ConvertShiftService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.convertShift();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    status: any,
    date: any,
    shift: any,
  ): {
    status: any;
    date: any;
    shift: any;
  } {
    const params: {
      status: any;
      date: any;
      shift: any;
    } = {
      status,
      date,
      shift,
    };

    return params;
  }
}
